import { handleWithErrorMessage } from "@/services/utils";
import api from "@/services/modules/organisations/organisation-message-templates";
import {
  SET_IS_FETCHING_ORGANISATION_MESSAGE_TEMPLATES,
  SET_ORGANISATION_MESSAGE_TEMPLATES,
  SET_IS_ADDING_ORGANISATION_MESSAGE_TEMPLATE,
  SET_IS_EDITING_ORGANISATION_MESSAGE_TEMPLATE
} from "@/store/modules/organisations/organisation-message-templates/mutations";

export const FETCH_ORGANISATION_MESSAGE_TEMPLATES =
  "FETCH_ORGANISATION_MESSAGE_TEMPLATES";
export const ADD_ORGANISATION_MESSAGE_TEMPLATE =
  "ADD_ORGANISATION_MESSAGE_TEMPLATE";
export const EDIT_ORGANISATION_MESSAGE_TEMPLATE =
  "EDIT_ORGANISATION_MESSAGE_TEMPLATE";
export const ADD_MESSAGE_TEMPLATE_FILE = "ADD_MESSAGE_TEMPLATE_FILE";

const actions = {
  async [FETCH_ORGANISATION_MESSAGE_TEMPLATES]({ commit, dispatch }, params) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api(commit).getAll(params),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_ORGANISATION_MESSAGE_TEMPLATES, isLoading),
      setDataFunction: ({ data }) =>
        commit(SET_ORGANISATION_MESSAGE_TEMPLATES, data)
    });
  },
  async [ADD_ORGANISATION_MESSAGE_TEMPLATE]({ commit, dispatch }, data) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api(commit).add(data),
      setLoadingFunction: isLoading =>
        commit(SET_IS_ADDING_ORGANISATION_MESSAGE_TEMPLATE, isLoading)
    });
  },
  async [EDIT_ORGANISATION_MESSAGE_TEMPLATE]({ commit, dispatch }, data) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api(commit).edit(data),
      setLoadingFunction: isLoading =>
        commit(SET_IS_EDITING_ORGANISATION_MESSAGE_TEMPLATE, isLoading)
    });
  },
  async [ADD_MESSAGE_TEMPLATE_FILE]({ dispatch, commit }, { id, data }) {
    return handleWithErrorMessage({
      request: () => api(commit).createMessageTemplateFile(id, data),
      dispatch
    });
  }
};

export default actions;
